import React from 'react';
import {
  SalesforceAccount,
  SalesforceAccountField,
  useUpdateSalesforceAccountFieldValueMutation,
} from 'api';

interface Props {
  field: SalesforceAccountField;
  salesforceAccount: SalesforceAccount;
}

const Text = ({field, salesforceAccount}: Props) => {
  const value = salesforceAccount.addition[`${field.fieldName}`];
  const [errorMessage, setErrorMessage] = React.useState('');
  const [updateFieldValue] = useUpdateSalesforceAccountFieldValueMutation({
    onCompleted: (data) => {
      setErrorMessage(data.updateSalesforceAccountFieldValue.error);
    },
  });

  return (
    <>
      <input
        defaultValue={value}
        className="w-max"
        onBlur={(e) => {
          updateFieldValue({
            variables: {
              salesforceAccountId: salesforceAccount.id,
              attributes: {fieldName: field.fieldName, value: e.target.value},
            },
          });
        }}
      />
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default Text;
